import React from "react";
import ReactDom from 'react-dom';
import "./Entrance.less";
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import { Toast } from 'antd-mobile';
import Dialog from "../dialog/Dialog";
export default class Entrance extends OfficialPage {
  state = {
    islogin: false,
    isHavePhone: false,
    historyList: [],
    canUseIntegral: 0,
    userVipCardInfo: null, //会员信息
    isShowHead: true,
    twiceScroll: false,
    isNeedVip: false,
    isNeedIntegral: false,
  }
  constructor(props) {
    super(props);
    document.title = '即速对话';
    window.addEventListener('scroll', this.handleScroll);
    this.myRef = React.createRef();
  }
  componentDidMount() {
    app.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
    if (app.isLogin()) {
      this.setState({
        islogin: true
      })
      if(app.getUserInfo().phone){
        this.getSessionList();
        this.getIntegralDetailData();
        this.getIntegralInfo();
        this.getVipInfo();
        this.setState({
          isHavePhone: true
        })
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll = () => {
    let ele = ReactDom.findDOMNode(this.myRef.current);
    let top = ele.getBoundingClientRect().top;
    if(top <= 74){
      this.setState({
        isShowHead: false
      })
    }
  }
  historyScroll = (event) => {
    const { scrollTop } = event.target;
    if(scrollTop > 20){
      this.setState({
        twiceScroll: true
      })
    }
    if(!this.state.isShowHead && scrollTop < 18 && this.state.twiceScroll){
      this.setState({
        isShowHead: true,
        twiceScroll: false
      })
    }
  }
  goTop = () => {
    this.setState({
      isShowHead: true
    })
  }
  // 获取会员信息
  getVipInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      hideLoading: true,
      success: (res) => {
       if(res.status == 0){
        that.setState({
          userVipCardInfo: res.data.user_paid_vip_card,
          isNeedVip: Boolean(res.data.all_vip_card.length),
        })
       }
      }
    })
  }
  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      success: function (res) {
        let integralLength =
          ('' + res.data.can_use_integral).length +
          ('' + res.data.total_integral).length
        let fontSize = integralLength > 0 ? 60 - integralLength * 2 : 60
        that.setState({
          canUseIntegral: res.data.can_use_integral,
          totalIntegral: res.data.total_integral,
          integralFontSize: fontSize
        })
      }
    })
  }
  getIntegralInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
      hideLoading: true,
      data: {
        app_id: app.getAppId(),
        card_type: 2
      },
      success: (res) => {
        if(res.status != 0){return}
        that.setState({
          isNeedIntegral: Boolean(res.data.length)
        })
      }
    })
  }
  // 获取列表
  getSessionList = () => {
    let that = this
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/SessionList',
      data: {
        app_id: app.getAppId(),
        page: 1,
        page_size: 10
      },
      method: 'POST',
      success: function (res) {
        app.hideLoading();
        let hisArr = res.data.map(item => {
          if(!item.content){
            item.content = '暂无对话';
          }
          item.isEdit = false
          return item
        })
        that.setData({
          historyList: hisArr
        })
      }
    })
  }

  goStart = () => {
    if(this.state.islogin){
      if(this.state.isHavePhone){
        app.removeStorage({key: 'nowSessionData'})
        app.turnToPage('gptIndex');
      }else{
        Toast.info('请补充用户信息',1,()=>{
          app.turnToPage('add-phone')
        });
      }
    }else{
      app.goLogin();
    }
  }
  goHistoryDetail = event => {
    let id = event.currentTarget.dataset.id;
    let rid = event.currentTarget.dataset.rid;
    app.turnToPage('gptIndex?sid=' + id + '&rid=' + rid);
  }
  goUserCenter = () => {
    app.turnToPage('userCenterComponentPage');
  }
  debubbling = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }
  edit = event => {
    this.debubbling(event);
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.isEdit = true;
      }
      return item;
    })
    this.setData({
      historyList: hisArr
    })
  }
  bindTextInput = (event) => {
    let val = event.target.value;
    let id = event.currentTarget.dataset.id;
    let hisArr = this.data.historyList.map(item => {
      if(item.id == id){
        item.content = val;
      }
      return item;
    })
    this.setData({
      historyList: hisArr
    })
  }
  noConf = event => {
    this.debubbling(event);
    this.getSessionList();
    // let id = event.currentTarget.dataset.id;
    // let hisArr = this.data.historyList.map(item => {
    //   if(item.id == id){
    //     item.isEdit = false;
    //   }
    //   return item;
    // })
    // this.setData({
    //   historyList: hisArr
    // })
  }
  conf = event => {
    this.debubbling(event);
    let that = this
    let id = event.currentTarget.dataset.id;
    let val = event.currentTarget.dataset.val;
    app.showLoading({
      title: '加载中..',
    })
    app.sendRequest({
      url: '/index.php?r=ChatAI/UpdateSessionTitle',
      data: {
        app_id: app.getAppId(),
        id: id,
        title: val
      },
      method: 'POST',
      success: function (res) {
        if(!res.status){ 
          app.hideLoading();
          that.getSessionList();
        }
      }
    })
  }
  delete = event => {
    this.debubbling(event);
    let id = event.currentTarget.dataset.id;
    let that = this
    Dialog.showModal({
      title: '是否确定删除对话',
      content: '删除后无法恢复，请谨慎操作',
      confirmText: '删除',
      status: 'delete',
      confirm: () => {
        app.sendRequest({
          url: '/index.php?r=ChatAI/CreateSession',
          data: {
            app_id: app.getAppId(),
            is_deleted: 1,
            id: id
          },
          hideLoading: true,
          method: 'POST',
          success: function (res) {
            if(res.status == 0){
              Toast.info('删除完成');
              that.getSessionList();
            }else{
              Toast.info(res.data);
            }
          }
        })
      },
    })
  }
  goRecharge = () => {
    app.turnToPage('gptrecharge');
  }
  render() {
    let userInfo = app.getUserInfo();
    let { canUseIntegral, islogin, historyList,isHavePhone, userVipCardInfo,isShowHead,isNeedVip, isNeedIntegral, } = this.state;
    return (
      <div className="historical_page">
        {
          !isShowHead && <div className="top" onClick={this.goTop}>
          <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/top.png" />
        </div>
        }
        {/* {isHavePhone && (
        <div className="head_box" onClick={this.goUserCenter}>
          <img className="headimg" src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt="" />
          <div className="head_con">
            <div>积分</div>
            <div>{ canUseIntegral }</div>
          </div>
        </div>
        )} */}
        {!isHavePhone ? (
        <div className="slogan">
          <div className="line1">你好！</div>
          <div className="line2">欢迎进入即速对话~</div>
        </div>
        ):(
          isShowHead && 
        <div className="head">
          <img className="headimg" onClick={this.goUserCenter} src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt="" />
          <div className="head_con">
            <div className="row">
              <div>{userInfo.phone}</div>
              {isNeedVip == true && (
                <div className="vipimg_box">
                  <img className="vipimg" 
                  onClick={!userVipCardInfo?this.goRecharge:null}
                  src={!userVipCardInfo?"https://cdn.jisuapp.cn/static/webapp/images/chatgpt/novip.png":"https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog2.png"}/>
                </div>
              )}
            </div>
            <div>积分：{ canUseIntegral }</div>
          </div>
          {(isNeedVip == true || isNeedIntegral == true) && (
          <div className="head_btn" onClick={this.goRecharge}>去充值</div>
          )}
        </div>
        )}
        
        {isHavePhone && (
          <div className={isShowHead?"main":"main fixed"} ref={this.myRef}>
          <div className="title">历史对话</div>
          <div className={isShowHead?"historical":"historical histor_box"} onScroll={this.historyScroll}>
          {historyList.map((item, index) =>
          <div className="historical_item" key={index} onClick={this.goHistoryDetail} data-id={item.id} data-rid={item.role_play_id}>
            <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/dialogue2.png" alt="dialogue" className="it_l"/>
            <div className="it_r">
              <div className="it_r_t">
                <div>{item.humanized_time}</div>
                <div className="it_r_t_btn">
                  <div className="btn_img" onClick={this.edit} data-id={item.id}><img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/edit.png" alt="edit" /></div>
                  <div className="btn_img" onClick={this.delete} data-id={item.id}><img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/del.png" alt="del" /></div>
                </div> 
              </div>
              <div className="it_r_b">
                {item.isEdit?
                <div className="row edit_line" onClick={this.debubbling}>
                  <input type="text" onInput={this.bindTextInput} onChange={this.bindTextInput} data-id={item.id} value={item.content}/>
                  <label className='ico-moon icon-gou mar_rl8' onClick={this.conf} data-id={item.id} data-val={item.content}></label>
                  <label className='ico-moon icon-closes mar_rl8' onClick={this.noConf} data-id={item.id}></label>
                </div> : 
                <span>{item.content}</span>
                }
              </div>
            </div>
          </div>
          )}
          {historyList.length == 0 && <div>暂无历史记录</div>}
          </div> 
        </div>
        )}
        <div className="footer">
          {!userVipCardInfo && isHavePhone &&
            (
              isNeedVip == true ? <div className="foot_dsc">非会员最多仅能创建四个会话，会员无限，<a onClick={this.goRecharge}>去开通</a></div>
              : <div className="foot_dsc">最多仅能创建四个会话</div>
            )
          }
          <div className="gobtn" onClick={this.goStart}>开启对话</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/entrance/Entrance.jsx